import { endOfDay as endOfDayFns } from 'date-fns';

export default function endOfDay(date: Date): Date {
  return endOfDayFns(date);
}
